export const base_path_img = "/";
export const base_path = "/";
// change this to localhost when you run on local
//export const BASE_URL = "185.196.21.84";
export const BASE_URL = "localhost";
export const API_BASE_URL = "http://localhost:8000/api";